// kk-attribution.js  (LAST-TOUCH WINS)
//
// Reads repID + eventID from the query string, writes them to Shopify cart attributes,
// and (optionally) strips them from the URL afterward.

(async () => {
  try {
    const url = new URL(window.location.href);
    const repID = url.searchParams.get('repID');
    const eventID = url.searchParams.get('eventID');

    // Only do work if at least one param is present
    if (!repID && !eventID) return;

    // Read current cart
    const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json());
    const attributes = { ...(cart.attributes || {}) };

    // LAST-TOUCH WINS: overwrite whenever URL contains a value
    if (repID) attributes.RepID = repID;
    if (eventID) attributes.EventID = eventID;

    // Persist to cart (Shopify Ajax Cart API)
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ attributes })
    });

    // Optional: remove params so customers don't share rep/event IDs accidentally
    // url.searchParams.delete('repID');
    // url.searchParams.delete('eventID');
    // history.replaceState({}, '', url.pathname + (url.search ? url.search : '') + url.hash);
  } catch (err) {
    // Silent fail in production; uncomment for debugging if needed:
    // console.error('kk-attribution error', err);
  }
})();
